import type { LocaleMessageBundle } from '../../types'

export const offboardingMessages: LocaleMessageBundle = {
  vi: {
    'staff.offboarding.title': 'Nghỉ việc & bàn giao',
    'staff.offboarding.create': 'Thêm hồ sơ nghỉ việc',
    'staff.offboarding.edit': 'Cập nhật hồ sơ nghỉ việc',
    'staff.offboarding.detail': 'Chi tiết hồ sơ nghỉ việc',
    'staff.offboarding.search': 'Tìm mã hồ sơ, nhân viên',
    'staff.offboarding.code': 'Mã hồ sơ',
    'staff.offboarding.staff': 'Nhân viên',
    'staff.offboarding.branch': 'Chi nhánh',
    'staff.offboarding.type': 'Loại nghỉ việc',
    'staff.offboarding.status': 'Trạng thái',
    'staff.offboarding.reason': 'Lý do nghỉ việc',
    'staff.offboarding.notes': 'Ghi chú',
    'staff.offboarding.requestedDate': 'Ngày tạo đơn',
    'staff.offboarding.proposedLastWorkingDate': 'Ngày làm việc cuối (đề xuất)',
    'staff.offboarding.proposedTerminationDate': 'Ngày chấm dứt (đề xuất)',
    'staff.offboarding.approvedLastWorkingDate': 'Ngày làm việc cuối (xác nhận)',
    'staff.offboarding.effectiveTerminationDate': 'Ngày chấm dứt hiệu lực',
    'staff.offboarding.handoverDeadline': 'Hạn bàn giao',
    'staff.offboarding.noticePeriodDays': 'Số ngày báo trước',
    'staff.offboarding.validation.noticePeriodInteger': 'Số ngày báo trước phải là một số nguyên.',
    'staff.offboarding.validation.noticePeriodMax': 'Số ngày báo trước không được lớn hơn 365 ngày.',
    'staff.offboarding.assetReturnNote': 'Ghi chú tài sản thu hồi',
    'staff.offboarding.assetReturnNoteHint':
      'Liệt kê tài sản đã thu hồi hoặc nhập “Không có tài sản cần thu hồi”.',
    'staff.offboarding.sendNow': 'Gửi duyệt ngay sau khi tạo',
    'staff.offboarding.progress': 'Tiến độ bàn giao',
    'staff.offboarding.employee': 'Nhân viên',
    'staff.offboarding.createdBy': 'Người tạo',
    'staff.offboarding.createdAt': 'Ngày tạo',
    'staff.offboarding.completedAt': 'Ngày hoàn tất',
    'staff.offboarding.actions': 'Thao tác',
    'staff.offboarding.mine': 'Hồ sơ của tôi',
    'staff.offboarding.all': 'Tất cả hồ sơ',
    'staff.offboarding.summary': 'Tổng quan',
    'staff.offboarding.empty': 'Chưa có hồ sơ nghỉ việc.',
    'staff.offboarding.loading': 'Đang tải hồ sơ...',
    'staff.offboarding.tabs.info': 'Thông tin',
    'staff.offboarding.tabs.tasks': 'Bàn giao',
    'staff.offboarding.tabs.confirmations': 'Xác nhận',
    'staff.offboarding.tabs.history': 'Lịch sử',
    'staff.offboarding.tabs.documents': 'Tài liệu',
    'staff.offboarding.action.update': 'Cập nhật',
    'staff.offboarding.action.send': 'Gửi duyệt',
    'staff.offboarding.action.approve': 'Duyệt',
    'staff.offboarding.action.reject': 'Từ chối',
    'staff.offboarding.action.requestRevision': 'Yêu cầu bổ sung',
    'staff.offboarding.action.confirmDate': 'Xác nhận ngày nghỉ',
    'staff.offboarding.action.handoverConfirm': 'Xác nhận bàn giao',
    'staff.offboarding.action.financeConfirm': 'Xác nhận công nợ',
    'staff.offboarding.action.accessConfirm': 'Xác nhận thu hồi quyền & tài sản',
    'staff.offboarding.action.complete': 'Hoàn tất hồ sơ',
    'staff.offboarding.action.hold': 'Tạm dừng',
    'staff.offboarding.action.resume': 'Tiếp tục',
    'staff.offboarding.action.cancel': 'Hủy',
    'staff.offboarding.action.delete': 'Xóa',
    'staff.offboarding.action.taskManage': 'Thêm công việc bàn giao',
    'staff.offboarding.action.download': 'Tải xuống',
    'staff.offboarding.action.removeDocument': 'Xóa tài liệu',
    'staff.offboarding.action.uploadDocument': 'Tải tài liệu lên',
    'staff.offboarding.action.addTask': 'Thêm công việc',
    'staff.offboarding.action.completeTask': 'Hoàn thành',
    'staff.offboarding.action.skipTask': 'Bỏ qua',
    'staff.offboarding.action.reopenTask': 'Mở lại',
    'staff.offboarding.action.confirm': 'Xác nhận',
    'staff.offboarding.action.close': 'Đóng',
    'staff.offboarding.status.all': 'Tất cả',
    'staff.offboarding.status.DRAFT': 'Nháp',
    'staff.offboarding.status.PENDING_APPROVAL': 'Chờ duyệt',
    'staff.offboarding.status.NEEDS_REVISION': 'Cần bổ sung',
    'staff.offboarding.status.APPROVED': 'Đã duyệt',
    'staff.offboarding.status.IN_PROGRESS': 'Đang bàn giao',
    'staff.offboarding.status.ON_HOLD': 'Tạm dừng',
    'staff.offboarding.status.COMPLETED': 'Hoàn tất',
    'staff.offboarding.status.REJECTED': 'Từ chối',
    'staff.offboarding.status.CANCELLED': 'Đã hủy',
    'staff.offboarding.type.RESIGNATION': 'Tự nguyện nghỉ việc',
    'staff.offboarding.type.CONTRACT_EXPIRY': 'Hết hạn hợp đồng',
    'staff.offboarding.type.MUTUAL_AGREEMENT': 'Thỏa thuận chấm dứt',
    'staff.offboarding.type.EMPLOYER_TERMINATION': 'Công ty chấm dứt hợp đồng',
    'staff.offboarding.type.RETIREMENT': 'Nghỉ hưu',
    'staff.offboarding.type.OTHER': 'Khác',
    'staff.offboarding.category.WORK': 'Công việc',
    'staff.offboarding.category.DOCUMENT': 'Hồ sơ',
    'staff.offboarding.category.ACCESS': 'Quyền truy cập',
    'staff.offboarding.category.FINANCE': 'Tài chính',
    'staff.offboarding.category.OTHER': 'Khác',
    'staff.offboarding.taskStatus.PENDING': 'Chưa bắt đầu',
    'staff.offboarding.taskStatus.IN_PROGRESS': 'Đang thực hiện',
    'staff.offboarding.taskStatus.COMPLETED': 'Hoàn tất',
    'staff.offboarding.taskStatus.SKIPPED': 'Bỏ qua',
    'staff.offboarding.task.title': 'Tên công việc',
    'staff.offboarding.task.category': 'Nhóm',
    'staff.offboarding.task.description': 'Mô tả',
    'staff.offboarding.task.assignee': 'Người phụ trách',
    'staff.offboarding.task.department': 'Bộ phận',
    'staff.offboarding.task.dueDate': 'Hạn hoàn thành',
    'staff.offboarding.task.required': 'Bắt buộc',
    'staff.offboarding.task.overdue': 'Quá hạn',
    'staff.offboarding.task.optional': 'Không bắt buộc',
    'staff.offboarding.task.comment': 'Ghi chú',
    'staff.offboarding.task.addTitle': 'Thêm công việc bàn giao',
    'staff.offboarding.task.editTitle': 'Cập nhật công việc bàn giao',
    'staff.offboarding.task.empty': 'Chưa có công việc bàn giao.',
    'staff.offboarding.confirm.handoverTitle': 'Xác nhận bàn giao',
    'staff.offboarding.confirm.handoverDescription':
      'Xác nhận nhân viên đã bàn giao công việc, hồ sơ và tài liệu.',
    'staff.offboarding.confirm.financeTitle': 'Xác nhận công nợ tài chính',
    'staff.offboarding.confirm.financeDescription':
      'Xác nhận đã hoàn tất lương, tạm ứng, phụ cấp và công nợ liên quan.',
    'staff.offboarding.confirm.accessTitle': 'Xác nhận thu hồi quyền truy cập & tài sản',
    'staff.offboarding.confirm.accessDescription':
      'Khóa tài khoản, thu hồi thiết bị và ghi rõ tài sản đã thu hồi.',
    'staff.offboarding.confirm.confirmedAt': 'Xác nhận lúc',
    'staff.offboarding.confirm.confirmedBy': 'Người xác nhận',
    'staff.offboarding.confirm.notConfirmed': 'Chưa xác nhận',
    'staff.offboarding.confirm.amountDue': 'Số tiền phải thu',
    'staff.offboarding.confirm.amountConfirmed': 'Số tiền đã xác nhận',
    'staff.offboarding.completion.title': 'Điều kiện hoàn tất',
    'staff.offboarding.completion.ready': 'Hồ sơ đủ điều kiện hoàn tất.',
    'staff.offboarding.completion.blockers': 'Còn việc chưa hoàn tất:',
    'staff.offboarding.completion.HANDOVER_NOT_CONFIRMED': 'Chưa xác nhận bàn giao',
    'staff.offboarding.completion.FINANCE_NOT_CONFIRMED': 'Chưa xác nhận công nợ',
    'staff.offboarding.completion.ACCESS_NOT_CONFIRMED': 'Chưa xác nhận thu hồi quyền truy cập',
    'staff.offboarding.completion.ASSET_NOTE_REQUIRED': 'Chưa ghi chú tài sản thu hồi',
    'staff.offboarding.completion.REQUIRED_TASK_OPEN': 'Còn công việc bắt buộc chưa hoàn thành',
    'staff.offboarding.completion.DATE_NOT_CONFIRMED': 'Chưa xác nhận ngày làm việc cuối và ngày chấm dứt',
    'staff.offboarding.completion.INVALID_STATUS': 'Hồ sơ không ở trạng thái có thể hoàn tất',
    'staff.offboarding.history.empty': 'Chưa có lịch sử.',
    'staff.offboarding.history.CREATED': 'Tạo hồ sơ',
    'staff.offboarding.history.UPDATED': 'Cập nhật hồ sơ',
    'staff.offboarding.history.SUBMITTED': 'Gửi duyệt',
    'staff.offboarding.history.APPROVED': 'Duyệt hồ sơ',
    'staff.offboarding.history.REJECTED': 'Từ chối hồ sơ',
    'staff.offboarding.history.REVISION_REQUESTED': 'Yêu cầu bổ sung',
    'staff.offboarding.history.DATE_CONFIRMED': 'Xác nhận ngày nghỉ',
    'staff.offboarding.history.DATE_CHANGED': 'Đổi ngày nghỉ',
    'staff.offboarding.history.CHECKLIST_GENERATED': 'Sinh danh mục bàn giao',
    'staff.offboarding.history.HANDOVER_CONFIRMED': 'Xác nhận bàn giao',
    'staff.offboarding.history.FINANCE_CONFIRMED': 'Xác nhận công nợ',
    'staff.offboarding.history.ACCESS_REVOKED_CONFIRMED': 'Xác nhận thu hồi quyền & tài sản',
    'staff.offboarding.history.COMPLETED': 'Hoàn tất hồ sơ',
    'staff.offboarding.history.EFFECT_APPLIED': 'Áp dụng trạng thái nghỉ việc',
    'staff.offboarding.history.HELD': 'Tạm dừng hồ sơ',
    'staff.offboarding.history.RESUMED': 'Tiếp tục hồ sơ',
    'staff.offboarding.history.CANCELLED': 'Hủy hồ sơ',
    'staff.offboarding.history.TASK_CREATED': 'Thêm công việc',
    'staff.offboarding.history.TASK_ASSIGNED': 'Phân công công việc',
    'staff.offboarding.history.TASK_UPDATED': 'Cập nhật công việc',
    'staff.offboarding.history.TASK_COMPLETED': 'Hoàn thành công việc',
    'staff.offboarding.history.TASK_SKIPPED': 'Bỏ qua công việc',
    'staff.offboarding.history.DOCUMENT_UPLOADED': 'Tải tài liệu lên',
    'staff.offboarding.history.DOCUMENT_DELETED': 'Xóa tài liệu',
    'staff.offboarding.dialog.sendTitle': 'Gửi hồ sơ nghỉ việc để duyệt?',
    'staff.offboarding.dialog.sendHint':
      'Sau khi xác nhận, hồ sơ sẽ chuyển sang trạng thái Chờ duyệt để người có thẩm quyền tiếp nhận và xử lý.',
    'staff.offboarding.dialog.approveTitle': 'Duyệt hồ sơ nghỉ việc?',
    'staff.offboarding.dialog.approveHint': 'Xác nhận duyệt hồ sơ nghỉ việc này?',
    'staff.offboarding.dialog.rejectTitle': 'Từ chối hồ sơ nghỉ việc',
    'staff.offboarding.dialog.revisionTitle': 'Yêu cầu bổ sung hồ sơ',
    'staff.offboarding.dialog.dateTitle': 'Xác nhận ngày nghỉ việc',
    'staff.offboarding.dialog.handoverTitle': 'Xác nhận bàn giao',
    'staff.offboarding.dialog.financeTitle': 'Xác nhận công nợ',
    'staff.offboarding.dialog.accessTitle': 'Xác nhận thu hồi quyền truy cập & tài sản',
    'staff.offboarding.dialog.completeTitle': 'Hoàn tất hồ sơ nghỉ việc',
    'staff.offboarding.dialog.holdTitle': 'Tạm dừng hồ sơ',
    'staff.offboarding.dialog.resumeTitle': 'Tiếp tục hồ sơ',
    'staff.offboarding.dialog.cancelTitle': 'Hủy hồ sơ nghỉ việc',
    'staff.offboarding.dialog.deleteTitle': 'Xóa vĩnh viễn hồ sơ nháp?',
    'staff.offboarding.dialog.deleteHint': 'Hồ sơ nháp và toàn bộ dữ liệu liên quan sẽ bị xóa vĩnh viễn. Thao tác này không thể hoàn tác.',
    'staff.offboarding.dialog.comment': 'Ghi chú',
    'staff.offboarding.dialog.reason': 'Lý do',
    'staff.offboarding.dialog.dateHint':
      'Ngày chấm dứt hiệu lực phải bằng hoặc sau ngày làm việc cuối.',
    'staff.offboarding.dialog.completeHint':
      'Hệ thống sẽ khóa tài khoản và áp dụng trạng thái nghỉ việc vào ngày chấm dứt hiệu lực.',
    'staff.offboarding.dialog.skipTaskTitle': 'Bỏ qua công việc bàn giao',
    'staff.offboarding.dialog.uploadTitle': 'Tải tài liệu nghỉ việc',
    'staff.offboarding.documents.empty': 'Chưa có tài liệu.',
    'staff.offboarding.documents.type': 'Loại tài liệu',
    'staff.offboarding.documents.type.RESIGNATION_FORM': 'Đơn xin nghỉ việc',
    'staff.offboarding.documents.type.HANDOVER_MINUTES': 'Biên bản bàn giao',
    'staff.offboarding.documents.type.TERMINATION_DECISION': 'Quyết định chấm dứt hợp đồng',
    'staff.offboarding.documents.type.RECONCILIATION': 'Biên bản đối soát',
    'staff.offboarding.documents.type.OTHER': 'Tài liệu khác',
    'staff.offboarding.documents.deleteTitle': 'Xóa tài liệu?',
    'staff.offboarding.documents.deleteConfirm': 'Bạn có chắc chắn muốn xóa tài liệu này?',
    'staff.offboarding.notifications.createSuccess': 'Thêm hồ sơ nghỉ việc thành công.',
    'staff.offboarding.notifications.updateSuccess': 'Cập nhật hồ sơ nghỉ việc thành công.',
    'staff.offboarding.notifications.deleteSuccess': 'Xóa hồ sơ nghỉ việc thành công.',
    'staff.offboarding.notifications.sendSuccess': 'Gửi duyệt thành công.',
    'staff.offboarding.notifications.approveSuccess': 'Duyệt thành công.',
    'staff.offboarding.notifications.rejectSuccess': 'Từ chối thành công.',
    'staff.offboarding.notifications.revisionSuccess': 'Yêu cầu bổ sung thành công.',
    'staff.offboarding.notifications.confirmDateSuccess': 'Xác nhận ngày nghỉ thành công.',
    'staff.offboarding.notifications.handoverSuccess': 'Xác nhận bàn giao thành công.',
    'staff.offboarding.notifications.financeSuccess': 'Xác nhận công nợ thành công.',
    'staff.offboarding.notifications.accessSuccess': 'Xác nhận thu hồi quyền và tài sản thành công.',
    'staff.offboarding.notifications.completeSuccess': 'Hoàn tất hồ sơ thành công.',
    'staff.offboarding.notifications.holdSuccess': 'Tạm dừng hồ sơ thành công.',
    'staff.offboarding.notifications.resumeSuccess': 'Tiếp tục hồ sơ thành công.',
    'staff.offboarding.notifications.cancelSuccess': 'Hủy hồ sơ thành công.',
    'staff.offboarding.notifications.documentUploadSuccess': 'Thêm tài liệu thành công.',
    'staff.offboarding.notifications.documentDeleteSuccess': 'Xóa tài liệu thành công.',
    'staff.offboarding.errors.OFFBOARDING_DUPLICATE_ACTIVE':
      'Nhân viên đã có hồ sơ nghỉ việc đang xử lý.',
    'staff.offboarding.errors.OFFBOARDING_STAFF_NOT_ACTIVE':
      'Chỉ có thể tạo hồ sơ cho nhân viên đang làm việc hoặc đang bị khóa.',
    'staff.offboarding.errors.OFFBOARDING_NOT_SUBMITTABLE':
      'Hồ sơ không ở trạng thái có thể gửi duyệt.',
    'staff.offboarding.errors.OFFBOARDING_NOT_PENDING_APPROVAL':
      'Hồ sơ không ở trạng thái chờ duyệt.',
    'staff.offboarding.errors.OFFBOARDING_NOT_EDITABLE':
      'Chỉ có thể sửa hồ sơ nháp hoặc hồ sơ cần bổ sung.',
    'staff.offboarding.errors.OFFBOARDING_ONLY_DRAFT_CAN_BE_DELETED':
      'Chỉ có thể xóa vĩnh viễn hồ sơ đang ở trạng thái nháp.',
    'staff.offboarding.errors.OFFBOARDING_ALREADY_COMPLETED':
      'Hồ sơ đã hoàn tất và không thể thay đổi.',
    'staff.offboarding.errors.OFFBOARDING_SKIP_REASON_REQUIRED':
      'Vui lòng nhập lý do bỏ qua công việc.',
    'staff.offboarding.errors.OFFBOARDING_DATE_INVALID':
      'Ngày làm việc cuối phải bằng hoặc sau ngày tạo đơn; ngày chấm dứt phải bằng hoặc sau ngày làm việc cuối.',
    'staff.offboarding.errors.OFFBOARDING_DATES_NOT_CONFIRMABLE':
      'Không thể xác nhận ngày ở trạng thái hiện tại.',
    'staff.offboarding.errors.OFFBOARDING_NOT_IN_PROGRESS':
      'Hồ sơ phải đang ở trạng thái bàn giao.',
    'staff.offboarding.errors.OFFBOARDING_HANDOVER_TASKS_INCOMPLETE':
      'Vui lòng hoàn thành tất cả công việc bàn giao trước khi xác nhận.',
    'staff.offboarding.errors.OFFBOARDING_TASKS_NOT_EDITABLE':
      'Chỉ có thể sửa công việc khi hồ sơ đang bàn giao.',
    'staff.offboarding.errors.OFFBOARDING_NOT_COMPLETABLE':
      'Hồ sơ không ở trạng thái có thể hoàn tất.',
    'staff.offboarding.errors.OFFBOARDING_COMPLETION_BLOCKED':
      'Hồ sơ chưa đủ điều kiện hoàn tất. Vui lòng xử lý các mục còn thiếu.',
    'staff.offboarding.errors.OFFBOARDING_NOT_HOLDABLE': 'Không thể tạm dừng hồ sơ.',
    'staff.offboarding.errors.OFFBOARDING_NOT_RESUMABLE': 'Không thể tiếp tục hồ sơ.',
    'staff.offboarding.errors.OFFBOARDING_NOT_RESUMABLE_CURRENT_STATUS':
      'Hồ sơ hiện ở trạng thái {status}, nên không thể tiếp tục. Chỉ hồ sơ Tạm dừng mới tiếp tục được.',
    'staff.offboarding.errors.OFFBOARDING_NOT_CANCELLABLE': 'Không thể hủy hồ sơ.',
    'staff.offboarding.errors.OFFBOARDING_SELF_APPROVAL_FORBIDDEN':
      'Không thể tự duyệt hoặc tự xác nhận hồ sơ của chính mình.',
    'staff.offboarding.errors.OFFBOARDING_REASON_REQUIRED':
      'Vui lòng nhập lý do.',
    'staff.offboarding.errors.OFFBOARDING_REQUIRED_TASK_CANNOT_SKIP':
      'Không thể bỏ qua công việc bắt buộc.',
    'staff.offboarding.errors.OFFBOARDING_ASSET_NOTE_REQUIRED':
      'Vui lòng ghi rõ tài sản thu hồi hoặc “Không có tài sản cần thu hồi”.',
    'staff.offboarding.errors.OFFBOARDING_BRANCH_REQUIRED':
      'Nhân viên chưa được gán chi nhánh. Vui lòng chọn chi nhánh.',
    'staff.offboarding.errors.OFFBOARDING_DOCUMENT_UNSUPPORTED_TYPE':
      'Định dạng tài liệu không được hỗ trợ.',
    'staff.offboarding.errors.OFFBOARDING_DOCUMENT_TOO_LARGE':
      'Tài liệu vượt quá dung lượng 50MB.',
    'staff.offboarding.errors.OFFBOARDING_DOCUMENT_NOT_FOUND':
      'Không tìm thấy tài liệu đã tải lên.',
    'staff.offboarding.errors.OFFBOARDING_DOCUMENT_INVALID_KEY':
      'Tài liệu không thuộc hồ sơ này.',
    'staff.offboarding.errors.saveFailed': 'Không thể lưu hồ sơ nghỉ việc.',
    'staff.offboarding.errors.uploadFailed': 'Tải tài liệu thất bại.',
  },
  en: {
    'staff.offboarding.title': 'Offboarding & handover',
    'staff.offboarding.create': 'Add offboarding record',
    'staff.offboarding.edit': 'Edit offboarding',
    'staff.offboarding.detail': 'Offboarding details',
    'staff.offboarding.search': 'Search code or employee',
    'staff.offboarding.code': 'Code',
    'staff.offboarding.staff': 'Employee',
    'staff.offboarding.branch': 'Branch',
    'staff.offboarding.type': 'Offboarding type',
    'staff.offboarding.status': 'Status',
    'staff.offboarding.reason': 'Reason',
    'staff.offboarding.notes': 'Notes',
    'staff.offboarding.requestedDate': 'Requested date',
    'staff.offboarding.proposedLastWorkingDate': 'Proposed last working date',
    'staff.offboarding.proposedTerminationDate': 'Proposed termination date',
    'staff.offboarding.approvedLastWorkingDate': 'Confirmed last working date',
    'staff.offboarding.effectiveTerminationDate': 'Effective termination date',
    'staff.offboarding.handoverDeadline': 'Handover deadline',
    'staff.offboarding.noticePeriodDays': 'Notice period (days)',
    'staff.offboarding.validation.noticePeriodInteger': 'Notice period must be an integer.',
    'staff.offboarding.validation.noticePeriodMax': 'Notice period must not exceed 365 days.',
    'staff.offboarding.assetReturnNote': 'Returned asset note',
    'staff.offboarding.assetReturnNoteHint':
      'List returned assets or enter “No assets to return”.',
    'staff.offboarding.sendNow': 'Submit for approval after saving',
    'staff.offboarding.progress': 'Handover progress',
    'staff.offboarding.employee': 'Employee',
    'staff.offboarding.createdBy': 'Created by',
    'staff.offboarding.createdAt': 'Created at',
    'staff.offboarding.completedAt': 'Completed at',
    'staff.offboarding.actions': 'Actions',
    'staff.offboarding.mine': 'My requests',
    'staff.offboarding.all': 'All requests',
    'staff.offboarding.summary': 'Summary',
    'staff.offboarding.empty': 'No offboarding records yet.',
    'staff.offboarding.loading': 'Loading offboarding...',
    'staff.offboarding.tabs.info': 'Information',
    'staff.offboarding.tabs.tasks': 'Handover',
    'staff.offboarding.tabs.confirmations': 'Confirmations',
    'staff.offboarding.tabs.history': 'History',
    'staff.offboarding.tabs.documents': 'Documents',
    'staff.offboarding.action.update': 'Edit',
    'staff.offboarding.action.send': 'Submit',
    'staff.offboarding.action.approve': 'Approve',
    'staff.offboarding.action.reject': 'Reject',
    'staff.offboarding.action.requestRevision': 'Request changes',
    'staff.offboarding.action.confirmDate': 'Confirm dates',
    'staff.offboarding.action.handoverConfirm': 'Confirm handover',
    'staff.offboarding.action.financeConfirm': 'Confirm finance',
    'staff.offboarding.action.accessConfirm': 'Confirm access & assets',
    'staff.offboarding.action.complete': 'Complete',
    'staff.offboarding.action.hold': 'Hold',
    'staff.offboarding.action.resume': 'Resume',
    'staff.offboarding.action.cancel': 'Cancel',
    'staff.offboarding.action.delete': 'Delete',
    'staff.offboarding.action.taskManage': 'Add handover task',
    'staff.offboarding.action.download': 'Download',
    'staff.offboarding.action.removeDocument': 'Delete document',
    'staff.offboarding.action.uploadDocument': 'Upload document',
    'staff.offboarding.action.addTask': 'Add task',
    'staff.offboarding.action.completeTask': 'Complete',
    'staff.offboarding.action.skipTask': 'Skip',
    'staff.offboarding.action.reopenTask': 'Reopen',
    'staff.offboarding.action.confirm': 'Confirm',
    'staff.offboarding.action.close': 'Close',
    'staff.offboarding.status.all': 'All',
    'staff.offboarding.status.DRAFT': 'Draft',
    'staff.offboarding.status.PENDING_APPROVAL': 'Pending approval',
    'staff.offboarding.status.NEEDS_REVISION': 'Needs revision',
    'staff.offboarding.status.APPROVED': 'Approved',
    'staff.offboarding.status.IN_PROGRESS': 'In progress',
    'staff.offboarding.status.ON_HOLD': 'On hold',
    'staff.offboarding.status.COMPLETED': 'Completed',
    'staff.offboarding.status.REJECTED': 'Rejected',
    'staff.offboarding.status.CANCELLED': 'Cancelled',
    'staff.offboarding.type.RESIGNATION': 'Resignation',
    'staff.offboarding.type.CONTRACT_EXPIRY': 'Contract expiry',
    'staff.offboarding.type.MUTUAL_AGREEMENT': 'Mutual agreement',
    'staff.offboarding.type.EMPLOYER_TERMINATION': 'Employer termination',
    'staff.offboarding.type.RETIREMENT': 'Retirement',
    'staff.offboarding.type.OTHER': 'Other',
    'staff.offboarding.category.WORK': 'Work',
    'staff.offboarding.category.DOCUMENT': 'Documents',
    'staff.offboarding.category.ACCESS': 'Access',
    'staff.offboarding.category.FINANCE': 'Finance',
    'staff.offboarding.category.OTHER': 'Other',
    'staff.offboarding.taskStatus.PENDING': 'Pending',
    'staff.offboarding.taskStatus.IN_PROGRESS': 'In progress',
    'staff.offboarding.taskStatus.COMPLETED': 'Completed',
    'staff.offboarding.taskStatus.SKIPPED': 'Skipped',
    'staff.offboarding.task.title': 'Task title',
    'staff.offboarding.task.category': 'Category',
    'staff.offboarding.task.description': 'Description',
    'staff.offboarding.task.assignee': 'Assignee',
    'staff.offboarding.task.department': 'Department',
    'staff.offboarding.task.dueDate': 'Due date',
    'staff.offboarding.task.required': 'Required',
    'staff.offboarding.task.overdue': 'Overdue',
    'staff.offboarding.task.optional': 'Optional',
    'staff.offboarding.task.comment': 'Comment',
    'staff.offboarding.task.addTitle': 'Add handover task',
    'staff.offboarding.task.editTitle': 'Edit handover task',
    'staff.offboarding.task.empty': 'No handover tasks yet.',
    'staff.offboarding.confirm.handoverTitle': 'Handover confirmation',
    'staff.offboarding.confirm.handoverDescription':
      'Confirm the employee has handed over work, files and documents.',
    'staff.offboarding.confirm.financeTitle': 'Finance confirmation',
    'staff.offboarding.confirm.financeDescription':
      'Confirm salary, advances, allowances and related debts are settled.',
    'staff.offboarding.confirm.accessTitle': 'Access revocation & assets',
    'staff.offboarding.confirm.accessDescription':
      'Lock accounts, collect devices and record returned assets.',
    'staff.offboarding.confirm.confirmedAt': 'Confirmed at',
    'staff.offboarding.confirm.confirmedBy': 'Confirmed by',
    'staff.offboarding.confirm.notConfirmed': 'Not confirmed',
    'staff.offboarding.confirm.amountDue': 'Amount due',
    'staff.offboarding.confirm.amountConfirmed': 'Confirmed amount',
    'staff.offboarding.completion.title': 'Completion checklist',
    'staff.offboarding.completion.ready': 'This record is ready to complete.',
    'staff.offboarding.completion.blockers': 'Outstanding items:',
    'staff.offboarding.completion.HANDOVER_NOT_CONFIRMED': 'Handover not confirmed',
    'staff.offboarding.completion.FINANCE_NOT_CONFIRMED': 'Finance not confirmed',
    'staff.offboarding.completion.ACCESS_NOT_CONFIRMED': 'Access revocation not confirmed',
    'staff.offboarding.completion.ASSET_NOTE_REQUIRED': 'Returned asset note missing',
    'staff.offboarding.completion.REQUIRED_TASK_OPEN': 'Required tasks are still open',
    'staff.offboarding.completion.DATE_NOT_CONFIRMED': 'Last working and effective dates not confirmed',
    'staff.offboarding.completion.INVALID_STATUS': 'The record cannot be completed in its current status',
    'staff.offboarding.history.empty': 'No history yet.',
    'staff.offboarding.history.CREATED': 'Created',
    'staff.offboarding.history.UPDATED': 'Updated',
    'staff.offboarding.history.SUBMITTED': 'Submitted',
    'staff.offboarding.history.APPROVED': 'Approved',
    'staff.offboarding.history.REJECTED': 'Rejected',
    'staff.offboarding.history.REVISION_REQUESTED': 'Changes requested',
    'staff.offboarding.history.DATE_CONFIRMED': 'Dates confirmed',
    'staff.offboarding.history.DATE_CHANGED': 'Dates changed',
    'staff.offboarding.history.CHECKLIST_GENERATED': 'Checklist generated',
    'staff.offboarding.history.HANDOVER_CONFIRMED': 'Handover confirmed',
    'staff.offboarding.history.FINANCE_CONFIRMED': 'Finance confirmed',
    'staff.offboarding.history.ACCESS_REVOKED_CONFIRMED': 'Access and assets confirmed',
    'staff.offboarding.history.COMPLETED': 'Completed',
    'staff.offboarding.history.EFFECT_APPLIED': 'Offboarding applied',
    'staff.offboarding.history.HELD': 'Put on hold',
    'staff.offboarding.history.RESUMED': 'Resumed',
    'staff.offboarding.history.CANCELLED': 'Cancelled',
    'staff.offboarding.history.TASK_CREATED': 'Task created',
    'staff.offboarding.history.TASK_ASSIGNED': 'Task assigned',
    'staff.offboarding.history.TASK_UPDATED': 'Task updated',
    'staff.offboarding.history.TASK_COMPLETED': 'Task completed',
    'staff.offboarding.history.TASK_SKIPPED': 'Task skipped',
    'staff.offboarding.history.DOCUMENT_UPLOADED': 'Document uploaded',
    'staff.offboarding.history.DOCUMENT_DELETED': 'Document deleted',
    'staff.offboarding.dialog.sendTitle': 'Submit this offboarding request?',
    'staff.offboarding.dialog.sendHint':
      'After confirmation, the request will move to Pending approval for an authorized person to receive and process it.',
    'staff.offboarding.dialog.approveTitle': 'Approve this offboarding request?',
    'staff.offboarding.dialog.approveHint': 'Are you sure you want to approve this offboarding request?',
    'staff.offboarding.dialog.rejectTitle': 'Reject offboarding request',
    'staff.offboarding.dialog.revisionTitle': 'Request changes',
    'staff.offboarding.dialog.dateTitle': 'Confirm offboarding dates',
    'staff.offboarding.dialog.handoverTitle': 'Confirm handover',
    'staff.offboarding.dialog.financeTitle': 'Confirm finance',
    'staff.offboarding.dialog.accessTitle': 'Confirm access revocation & assets',
    'staff.offboarding.dialog.completeTitle': 'Complete offboarding',
    'staff.offboarding.dialog.holdTitle': 'Put offboarding on hold',
    'staff.offboarding.dialog.resumeTitle': 'Resume offboarding',
    'staff.offboarding.dialog.cancelTitle': 'Cancel offboarding',
    'staff.offboarding.dialog.comment': 'Comment',
    'staff.offboarding.dialog.reason': 'Reason',
    'staff.offboarding.dialog.dateHint':
      'The effective termination date must be on or after the last working date.',
    'staff.offboarding.dialog.completeHint':
      'The system will lock the account and apply the resigned status on the effective date.',
    'staff.offboarding.dialog.skipTaskTitle': 'Skip handover task',
    'staff.offboarding.dialog.uploadTitle': 'Upload offboarding document',
    'staff.offboarding.documents.empty': 'No documents yet.',
    'staff.offboarding.documents.type': 'Document type',
    'staff.offboarding.documents.type.RESIGNATION_FORM': 'Resignation form',
    'staff.offboarding.documents.type.HANDOVER_MINUTES': 'Handover minutes',
    'staff.offboarding.documents.type.TERMINATION_DECISION': 'Termination decision',
    'staff.offboarding.documents.type.RECONCILIATION': 'Reconciliation record',
    'staff.offboarding.documents.type.OTHER': 'Other document',
    'staff.offboarding.documents.deleteTitle': 'Delete document?',
    'staff.offboarding.documents.deleteConfirm': 'Are you sure you want to delete this document?',
    'staff.offboarding.notifications.createSuccess': 'Offboarding record added successfully.',
    'staff.offboarding.notifications.updateSuccess': 'Offboarding record updated successfully.',
    'staff.offboarding.notifications.deleteSuccess': 'Offboarding record deleted successfully.',
    'staff.offboarding.notifications.sendSuccess': 'Submitted for approval successfully.',
    'staff.offboarding.notifications.approveSuccess': 'Approved successfully.',
    'staff.offboarding.notifications.rejectSuccess': 'Rejected successfully.',
    'staff.offboarding.notifications.revisionSuccess': 'Changes requested successfully.',
    'staff.offboarding.notifications.confirmDateSuccess': 'Last working date confirmed successfully.',
    'staff.offboarding.notifications.handoverSuccess': 'Handover confirmed successfully.',
    'staff.offboarding.notifications.financeSuccess': 'Finance confirmed successfully.',
    'staff.offboarding.notifications.accessSuccess': 'Access and assets confirmed successfully.',
    'staff.offboarding.notifications.completeSuccess': 'Offboarding completed successfully.',
    'staff.offboarding.notifications.holdSuccess': 'Offboarding put on hold successfully.',
    'staff.offboarding.notifications.resumeSuccess': 'Offboarding resumed successfully.',
    'staff.offboarding.notifications.cancelSuccess': 'Offboarding cancelled successfully.',
    'staff.offboarding.notifications.documentUploadSuccess': 'Document added successfully.',
    'staff.offboarding.notifications.documentDeleteSuccess': 'Document deleted successfully.',
    'staff.offboarding.errors.OFFBOARDING_DUPLICATE_ACTIVE':
      'This employee already has an active offboarding request.',
    'staff.offboarding.errors.OFFBOARDING_STAFF_NOT_ACTIVE':
      'Only active or locked employees can be offboarded.',
    'staff.offboarding.errors.OFFBOARDING_NOT_SUBMITTABLE':
      'This record cannot be submitted in its current status.',
    'staff.offboarding.errors.OFFBOARDING_NOT_PENDING_APPROVAL':
      'This record is not pending approval.',
    'staff.offboarding.errors.OFFBOARDING_NOT_EDITABLE':
      'Only draft or revision-requested records can be edited.',
    'staff.offboarding.errors.OFFBOARDING_ONLY_DRAFT_CAN_BE_DELETED':
      'Only draft records can be permanently deleted.',
    'staff.offboarding.errors.OFFBOARDING_ALREADY_COMPLETED':
      'This record is already completed and cannot be changed.',
    'staff.offboarding.errors.OFFBOARDING_SKIP_REASON_REQUIRED':
      'Enter a reason for skipping the task.',
    'staff.offboarding.errors.OFFBOARDING_DATE_INVALID':
      'The last working date must be on or after the requested date, and the termination date must be on or after the last working date.',
    'staff.offboarding.errors.OFFBOARDING_DATES_NOT_CONFIRMABLE':
      'Dates cannot be confirmed in the current status.',
    'staff.offboarding.errors.OFFBOARDING_NOT_IN_PROGRESS':
      'The record must be in progress.',
    'staff.offboarding.errors.OFFBOARDING_HANDOVER_TASKS_INCOMPLETE':
      'Complete all handover tasks before confirming the handover.',
    'staff.offboarding.errors.OFFBOARDING_TASKS_NOT_EDITABLE':
      'Tasks can only be edited while the record is in progress.',
    'staff.offboarding.errors.OFFBOARDING_NOT_COMPLETABLE':
      'This record cannot be completed in its current status.',
    'staff.offboarding.errors.OFFBOARDING_COMPLETION_BLOCKED':
      'This record is not ready to complete. Resolve the remaining blockers first.',
    'staff.offboarding.errors.OFFBOARDING_NOT_HOLDABLE': 'This record cannot be put on hold.',
    'staff.offboarding.errors.OFFBOARDING_NOT_RESUMABLE': 'This record cannot be resumed.',
    'staff.offboarding.errors.OFFBOARDING_NOT_RESUMABLE_CURRENT_STATUS':
      'The record is currently {status}, so it cannot be resumed. Only records on hold can be resumed.',
    'staff.offboarding.errors.OFFBOARDING_NOT_CANCELLABLE': 'This record cannot be cancelled.',
    'staff.offboarding.errors.OFFBOARDING_SELF_APPROVAL_FORBIDDEN':
      'You cannot approve or confirm your own offboarding record.',
    'staff.offboarding.errors.OFFBOARDING_REASON_REQUIRED': 'Enter a reason.',
    'staff.offboarding.errors.OFFBOARDING_REQUIRED_TASK_CANNOT_SKIP':
      'A required task cannot be skipped.',
    'staff.offboarding.errors.OFFBOARDING_ASSET_NOTE_REQUIRED':
      'Record the returned assets or enter “No assets to return”.',
    'staff.offboarding.errors.OFFBOARDING_BRANCH_REQUIRED':
      'The employee has no branch. Please select a branch.',
    'staff.offboarding.errors.OFFBOARDING_DOCUMENT_UNSUPPORTED_TYPE':
      'Unsupported document type.',
    'staff.offboarding.errors.OFFBOARDING_DOCUMENT_TOO_LARGE':
      'The document exceeds the 50MB limit.',
    'staff.offboarding.errors.OFFBOARDING_DOCUMENT_NOT_FOUND':
      'The uploaded document was not found.',
    'staff.offboarding.errors.OFFBOARDING_DOCUMENT_INVALID_KEY':
      'This document does not belong to the record.',
    'staff.offboarding.errors.saveFailed': 'Unable to save the offboarding record.',
    'staff.offboarding.errors.uploadFailed': 'Document upload failed.',
  },
}
